const Swoosh = `url("https://img.rawpixel.com/s3fs-private/rawpixel_images/website_content/rm21-background-ae-31-g.jpg?w=1000&dpr=1&fit=default&crop=default&q=65&vib=3&con=3&usm=15&bg=F4F4F3&ixlib=js-2.2.1&s=72beeb494fc0c27b25409bc8aac29074");`;
export default Swoosh;
